import React from "react";
import styled from "styled-components";
import Auth from '../../../routes/Auth';

import AbbreviatedMillionNumberFormat from "../../../components/ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";
import SubmitDecisionsButton from "../../../components/ui-building-blocks/buttons/submit-decisions";

import { view } from "@risingstack/react-easy-state";

const PaddedTd = styled.td`
  padding: 12px;
`;

function CeoPanelDecisionsDepartmentSignoffs(props) {
  const {
    spending,
    submission_data,
    submitDecisions,
    submitDecisionsLoadingDevelopment,
    submitDecisionsLoadingMarketing,
    submitDecisionsLoadingOperations,
    submitDecisionsLoadingFinance,
    financial_decisions,
    unaccepted_decisions,
    showActionButtons,
    isPDPreChecked,
    isPMPreChecked,
    isOPPreChecked,
    isFNPreChecked
  } = props;
  const temporaryUser = Auth.getTemporaryUser();

  return (
    <div
      className="panel-dashboard-gray"
      id="ceo-decisions-department-signoffs"
      style={{ backgroundColor: "#faf9f9" }}
    >
      <h2 className="semibold" style={{ padding: "10px 0 0 10px" }}>
        Signoffs
      </h2>
      <div className="table table-responsive">
        <table>
          <thead>
            <tr>
              <td className="col-md-3 fs-16">Department</td>
              {!temporaryUser && (
                <td className="col-md-3 text-center fs-16">
                  Submission Status
                </td>
              )}
              <td className="col-md-3 text-center fs-16">
                <span>
                  Cash
                  <br />
                  <b className="red no-b">used</b>/received
                </span>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className="col-md-3">Product Management</th>
              {!temporaryUser && (
                <PaddedTd className="col-md-3 text-center">
                  <SubmitDecisionsButton
                    id="ceo-submit-decisions-pd"
                    tooltipPlacement="right"
                    data={submission_data.pd}
                    isLoading={submitDecisionsLoadingDevelopment}
                    isActive={showActionButtons}
                    onClick={() => submitDecisions("development")}
                    isPreChecked={isPDPreChecked}
                  />
                </PaddedTd>
              )}
              <td className="col-md-3 text-center fs-16">
                <AbbreviatedMillionNumberFormat
                  value={spending.pd}
                  prefix="$"
                  negativeClass="red"
                  forceConvert={true}
                />
              </td>
            </tr>
            <tr>
              <th className="col-md-3">Product Marketing</th>
              {!temporaryUser && (
                <PaddedTd className="col-md-3 text-center">
                  <SubmitDecisionsButton
                    id="ceo-submit-decisions-pm"
                    tooltipPlacement="right"
                    data={submission_data.pm}
                    isLoading={submitDecisionsLoadingMarketing}
                    isActive={showActionButtons}
                    onClick={() => submitDecisions("marketing")}
                    isPreChecked={isPMPreChecked}
                  />
                </PaddedTd>
              )}
              <td className="col-md-3 text-center fs-16">
                <AbbreviatedMillionNumberFormat
                  value={spending.pm}
                  prefix="$"
                  negativeClass="red"
                  forceConvert={true}
                />
              </td>
            </tr>
            <tr>
              <th className="col-md-3">Operations</th>
              {!temporaryUser && (
                <PaddedTd className="col-md-3 text-center">
                  <SubmitDecisionsButton
                    id="ceo-submit-decisions-op"
                    tooltipPlacement="right"
                    data={submission_data.op}
                    isLoading={submitDecisionsLoadingOperations}
                    isActive={showActionButtons}
                    onClick={() => submitDecisions("operations")}
                    isPreChecked={isOPPreChecked}
                  />
                </PaddedTd>
              )}
              <td className="col-md-3 text-center fs-16">
                <AbbreviatedMillionNumberFormat
                  value={spending.op}
                  prefix="$"
                  negativeClass="red"
                  forceConvert={true}
                />
              </td>
            </tr>
            <tr>
              <th className="col-md-3">Finance</th>
              {!temporaryUser && (
                <PaddedTd className="col-md-3 text-center">
                  <SubmitDecisionsButton
                    id="ceo-submit-decisions-fn"
                    tooltipPlacement="right"
                    data={submission_data.fn}
                    financial_decisions={financial_decisions}
                    unaccepted_decisions={unaccepted_decisions}
                    isLoading={submitDecisionsLoadingFinance}
                    isActive={showActionButtons}
                    onClick={() => submitDecisions("finance")}
                    isPreChecked={isFNPreChecked}
                  />
                </PaddedTd>
              )}
              <td className="col-md-3 text-center fs-16">
                <AbbreviatedMillionNumberFormat
                  value={spending.fn}
                  prefix="$"
                  negativeClass="red"
                  forceConvert={true}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default view(CeoPanelDecisionsDepartmentSignoffs);



// WEBPACK FOOTER //
// ./src/components/ceo/decisions/department-signoffs.js